import styled from 'styled-components'

export const Container = styled.article.attrs({
  className: 'tabs-container'
})`
  --tabs-header-height: 5rem;
  --tabs-header-background: transparent;
  --tabs-header-color: var(--gray20);
  --tabs-selected-background: transparent;
  --tabs-selected-color: #00aeef;
  --tabs-disabled-background: transparent;
  --tabs-disabled-color: var(--gray80);
  --tabs-success-background: transparent;
  --tabs-success-color: var(--green);
  --tabs-error-background: transparent;
  --tabs-error-color: var(--red);
`

export const SectionsWrapper = styled.div.attrs({
  className: 'tabs-section-wrapper'
})`
  width: 100%;

  display: flex;

  overflow-x: hidden;

  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
`

export const Section = styled.section`
  width: 100%;

  flex: none;

  scroll-snap-align: start;
`
